<template>
  <div>
    <card-box class="order_list document-all-content" v-loading="loading">
      <el-button slot="tt_r" type="primary" class="butn butn_one" @click="back">返回</el-button>
      <p slot="tt_r" type="text" class="order_list_p">新增授权人</p>
      <el-form ref="new_contact_form" :model="new_contact" label-width="200px" size="small" class="aut_add_forom">
        <el-form-item label="授权方" prop="name">
          <div class="name_test">
            <p>{{userInfo.userName}}</p>
            <p>{{userInfo.creditCode}}</p>
          </div>
        </el-form-item>
        <el-form-item label="被授权人账号" prop="name">
          <el-input v-model="new_contact.value" maxlength="11" placeholder="请输入个人账号" @blur="getsignatory()" @input="changeInputValue()"></el-input>
          <el-button icon="iconfont icon-bianzu1" @click="Address_book()" class="el-button_icon"></el-button>
        </el-form-item>
        <el-form-item label="被授权人姓名" prop="name">
          <el-input v-model="new_contact.remarkName" disabled maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="使用次数">
          <el-input-number class="el_input_number" :disabled="g_disabled" v-model="new_contact.usageCount" :min="1" :max="99999" label="描述文字"></el-input-number>
          <el-checkbox class="_checkbox" v-model="checked" @change="_checkbox">不控制</el-checkbox>
        </el-form-item>
        <el-form-item label="授权截止">
          <el-date-picker
            id="haofan_s"
            v-model="new_contact.sealUsageDate"
            type="datetime"
            :picker-options="pickerOptions"
            placeholder="选择日期时间"
            default-time="23:59:59"
          ></el-date-picker>
          <el-button icon="el-icon-date" @click="haofan" class="buyyon_icon"></el-button>
        </el-form-item>

        <el-form-item label="选择印章">
          <el-button class="mySeal_button" type="primary" @click="add_auth = true,get_mySeal(),get_allseal()">
            <i class="el-icon-plus el-icon--right"></i> 添加印章
          </el-button>
        </el-form-item>
        <el-form-item label="备注">
          <el-input class="remark_input" type="textarea" :rows="2" placeholder="请输入内容(最多100字)" v-model="new_contact.remark" maxlength="100"></el-input>
        </el-form-item>
        <div class="selected_seal" v-if="multipleSelectionOne.length>0">
          <p class="selected_seal_tot">已选印章（{{multipleSelectionOne.length}}枚）</p>
          <div class="selected_seal_list">
            <div v-for="(item2,index) in multipleSelectionOne" :key="index" class="selected_seal_list_div">
              <el-image :src="item2.sealSaveID | fileToUrl(mySeal_file)" fit="contain" class="selected_seal_list_img">
                <div slot="error" class="image-slot_one">
                  <img src="@/assets/img/user/signature.png" />
                  <p>签章丢失</p>
                </div>
              </el-image>
              <p class="selected_seal_list_test">{{item2.name}}</p>
              <el-button class="del_button" icon="el-icon-delete" @click="el_del(index)"></el-button>
            </div>
          </div>
        </div>
      </el-form>
      <div class="bottom_button">
        <el-button type="primary" class="qued_button" :loading="loading_yes" @click="add_seal_auth">发起授权</el-button>
        <el-button type="primary" class="quxiao_button">取消</el-button>
      </div>
    </card-box>
    <el-dialog :close-on-click-modal="false" v-dialogDrag title="选择被授权方" :visible.sync="del_seal_dialog" width="617" center>
      <p style="color: #A0A0A0;font-size: 14px">已选好友</p>
      <div class="selected_box">
        <div class="selected_div" v-for="(item,index)  in selected_friends" :key="index">
          <p style="color: #333333">{{item.userName || item.userAccount}}</p>
          <p style="color: #4A4A4A;font-size: 12px">{{item.userAccount}}</p>
          <i class="el-icon-close del_button_one" @click="selected_friends = []"></i>
        </div>
        <div class="data_null" v-if="selected_friends.length == 0">
          <p style="color:rgba(49,202,132,1);font-size: 18px;width: 100%;padding: 0;margin: 0">暂无选择</p>
        </div>
      </div>
      <el-divider></el-divider>
      <div class="con_input">
        <el-input placeholder="请输入内容" v-model="input3" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="add_date_name"></el-button>
        </el-input>
      </div>
      <el-table
        :data="options"
        header-row-class-name="contacts-header"
        style="width: 99%;margin: 0 auto"
        row-class-name="contact"
        class="contact_tb contact_tb_all"
        height="244px"
        :header-cell-style="{height: '40px',background:'#E5F6EE', color:'#47A078'}"
        stripe
      >
        <template slot="empty">
          <img src="@/assets/img/nullDate.png" style="width: 285px;height: 145px; margin-left: -67px;" />
          <p style="color:rgba(49,202,132,1);font-size: 18px;margin: 0">暂无数据</p>
        </template>
        <el-table-column prop="userName" align="center" label="姓名" :show-overflow-tooltip="true" header-align="center" key="1">
          <template slot-scope="scope">{{scope.row.userName||scope.row.userAccount}}</template>
        </el-table-column>
        <el-table-column prop="userAccount" align="center" label="账号" :show-overflow-tooltip="true" header-align="center" key="2"></el-table-column>
        <el-table-column label="账号类型" align="center">
          <template slot-scope="scope">{{ scope.row.userType==0?'个人账号':'企业账号'}}</template>
        </el-table-column>
        <el-table-column label="操作" align="center" key="3">
          <template slot-scope="scope">
            <span style=" cursor: pointer;color:#31ca84" @click="addData(scope.row)">确认选择</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :hide-on-single-page="hide_pagination"
        background
        :page-size="pageSize"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="prev, pager, next,jumper"
        :total="pages_total"
      ></el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="qued_button" @click="add_selected_data">确定</el-button>
        <el-button @click="del_seal_dialog=false" plain>取消</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" v-dialogDrag title="授权印章选择" :visible.sync="add_auth" width="1030" center class="el_dialoge">
      <p style="color: #A0A0A0;font-size: 14px">已选印章（{{checkBoxData.length}}枚）</p>
      <el-carousel class="list" :autoplay="false" :loop="false" :interval="5000" indicator-position="none" :arrow="mySignature.length>1?'always':'never'">
        <el-carousel-item class="seal_carousel_item" v-for="(item,index) in mySignature" :key="index">
          <div v-for="(item2,index) in item" :key="index" class="seal_33">
            <div class="list_seal">
              <div class="img_seal">
                <el-image :src="item2.sealSaveID | fileToUrl(mySeal_file)" fit="contain">
                  <div slot="error" class="image-slot image-slot_one">
                    <img src="@/assets/img/user/Signature_s.png" />
                    <p>印章丢失</p>
                  </div>
                </el-image>
              </div>
              <div class="msg_seal">
                <p class="text">{{item2.name}}</p>
                <i class="el-icon-close del_button_one" @click="el_del_o(item2.sealSaveID)"></i>
              </div>
            </div>
          </div>
        </el-carousel-item>
        <div class="data_null" v-if="mySignature.length==0">
          <p style="color:rgba(49,202,132,1);font-size: 18px;width: 100%;padding: 0;margin: 0">暂无选择</p>
        </div>
      </el-carousel>
      <el-divider></el-divider>
      <div class="el_dialoge_box">
        <div class="query-bar">
          <el-form :inline="true" :model="screen_form" class="demo-form-inline" size="small">
            <el-form-item label="我的印章">
              <el-input clearable v-model="screen_form.name" class="input_el" maxlength="50" placeholder="输入印章名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="screen_form.sealType" clearable placeholder="请选择印章类型">
                <el-option label="法定名称章(公章)" :value="1"></el-option>
                <el-option label="财务专用章" :value="2"></el-option>
                <el-option label="发票专用章" :value="3"></el-option>
                <el-option label="合同专用章" :value="4"></el-option>
                <el-option label="法定代表人名章" :value="5"></el-option>
                <el-option label="其他类型章" :value="9"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="query()">查询印章</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <el-checkbox class v-model="checkList" @change="_checkList">选中全部印章</el-checkbox>
            </el-form-item>
          </el-form>
        </div>
        <div class="seal_box">
          <div class="seal_box_div" v-for="(item,index) in mySeal" :key="index">
            <div class="seal_box_list" @click="choosed(index,item)" ref="liId">
              <div class="seal_box_list_img">
                <el-image :src="item.sealSaveID | fileToUrl(mySeal_file)" fit="contain">
                  <div slot="error" class="image-slot image-slot_one">
                    <img src="@/assets/img/user/Signature_s.png" />
                    <p>印章丢失</p>
                  </div>
                </el-image>
              </div>
              <div class="seal_box_list_test">
                <p>{{item.name}}</p>
                <p>{{item.creationDate}}</p>
              </div>
              <i class="el-icon-check choose_one"></i>
            </div>
          </div>
          <div class="data_null" v-if="mySeal.length==0">
            <p style="color:rgba(49,202,132,1);font-size: 18px;width: 100%;padding: 0;margin: 0">暂无数据</p>
          </div>
        </div>
        <el-pagination
          :hide-on-single-page="hide_pagination"
          background
          :page-size="pageSize_1"
          @size-change="handleSizeChange_one"
          @current-change="handleCurrentChange_one"
          layout="prev, pager, next,jumper"
          :total="pages_total_1"
        ></el-pagination>
        <div class="button_bottom">
          <el-button @click="determine" class="qued_button">确定</el-button>
          <el-button class="quxiao_button" @click="add_auth = false">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'authorized_person',
  data() {
    return {
      new_contact: {
        usageCount: 1,
        value: '',
        remarkName: ''
      },
      checkList: false,
      loading_yes: false,
      loading: false,
      pickerOptions: {
        disabledDate(time) {
          var lstDate = new Date('2038-01-18')
          return time.getTime() < Date.now() - 8.64e7 || time > lstDate.getTime(lstDate)
        }
      },
      input2: '',
      input3: '',
      checked: false,
      screen_form: {},
      options: [],
      options_o: {},
      add_auth: false,
      mySeal: [],
      mySeal_file: [],
      sealType: {
        '01': '法定名称章(公章)',
        '02': '财务专用章',
        '04': '合同专用章',
        '05': '法定代表人名章'
      },
      multipleSelection: {},
      multipleSelectionOne: [],
      selected_friends: [],
      mySignature: [],
      sealType_one: '',
      name: '',
      pageSize: 5,
      pageSize_1: 8,
      pageNum: 1,
      pageNum_s: 1,
      pages_total: 0,
      pages_total_1: 0,
      hide_pagination: false,
      g_disabled: false,
      del_seal_dialog: false,
      checkBox: [],
      checkBoxData: [],
      recordList: [],
      allDate: [],
      newDATA: [],

      personId: '',
      userInfo: this.$SIF.getLocalStorage('userInfo'),

      onpresscTime: 0
    }
  },
  created() {
    this.get_contacts()
  },
  methods: {
    addData(i) {
      if (i.userType == 0) {
        this.selected_friends = [i]
      } else {
        this.$message({
          message: '被授权用户只能是个人用户.',
          type: 'warning'
        })
        return
      }
    },
    back() {
      this.$router.go(-1)
    },
    _checkList() {
      if (this.checkList == true) {
        this.get_allseal()
        this.checkBoxData = this.allDate
        // this.checkBoxData = this.unique(this.checkBoxData)
        this.mySignature = this.chunk(this.checkBoxData, 3)
        this.get_mySeal()
      } else {
        this.checkBoxData = []
        this.mySignature = this.chunk(this.checkBoxData, 3)
        this.get_mySeal()
      }
    },

    haofan() {
      document.getElementById('haofan_s').focus()
    },
    determine() {
      this.multipleSelectionOne = this.checkBoxData
      this.add_auth = false
    },
    el_del(index) {
      for (var i = 0; i < this.multipleSelectionOne.length; i++) {
        if (i == index) {
          this.multipleSelectionOne.splice(i, 1)
          // this.checkBox.splice(i, 1);
          this.checkBoxData.splice(i, 1)
          // this.checkBoxData = this.unique(this.checkBoxData)
          this.mySignature = this.chunk(this.checkBoxData, 3)
        }
      }
    },
    el_del_o(id) {
      for (var b = 0; b < this.mySeal.length; b++) {
        if (this.mySeal[b].sealSaveID == id) {
          this.$refs.liId[b].className = 'seal_box_list'
        }
      }
      // this.checkBoxData = this.unique(this.checkBoxData)
      for (var i = 0; i < this.checkBoxData.length; i++) {
        if (this.checkBoxData[i].sealSaveID == id) {
          this.checkBoxData.splice(i, 1)
          this.mySignature = this.chunk(this.checkBoxData, 3)
        }
      }
    },
    // 查询联系人
    add_date_name() {
      this.get_contacts()
    },
    // 确定选择通信录用户
    add_selected_data() {
      this.del_seal_dialog = false
      this.new_contact.value = this.selected_friends[0].userAccount
      this.getsignatory()
    },
    // input 输入校验
    changeInputValue() {
      if (!this.new_contact.value) {
        this.personId = ''
        this.new_contact.remarkName = ''
      }
    },
    // 账号输入之后校验 input失去焦点
    getsignatory() {
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (!reg.test(this.new_contact.value)) {
        this.$message({
          message: '个人账号格式不正确，请重新输入',
          type: 'warning'
        })
        this.personId = ''
        this.new_contact.remarkName = ''
        return false
      }
      this.get_user_check()
    },
    // 检查账上是否实名认证
    get_user_check() {
      this.$SIF.httpPost({
        url: this.$SIF._serve.usermanage + '/contacts/query/signatory',
        data: {
          queryValue: this.new_contact.value
        },
        succFun: res => {
          // authenStatus
          if (res.code == 10000 && res.data) {
            if (res.data.authenStatus == 1) {
              this.new_contact.remarkName = res.data.userName
              this.personId = res.data.id
              this.get_check()
            } else {
              this.personId = ''
              this.new_contact.remarkName = ''
              this.$message({
                message: '该用户尚未进行实名认证，无法授权！',
                type: 'warning'
              })
            }
          } else {
            this.personId = ''
            this.new_contact.remarkName = ''
            this.$message({
              message: '该用户尚未进行实名认证，无法授权！',
              type: 'warning'
            })
          }
        }
      })
    },
    // 检查被授权者是否被重复授权
    get_check() {
      this.$SIF.httpPost({
        url: this.$SIF._serve.auth + '/authorize/checkUserDuplicateAuth',
        data: {
          authorizeCompanyId: this.$SIF.getLocalStorage('userInfo').id,
          personId: this.personId
        },
        succFun: res => {
          if (res.code == 10000) {
            console.log(res)
          } else {
            this.personId = ''
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        },
        failFun: res => {
          this.personId = ''
          this.new_contact.value = ''
          this.new_contact.remarkName = ''
          this.$message({
            message: res.msg,
            type: 'warning'
          })
          return
        }
      })
    },
    // 发起授权
    add_seal_auth() {
      if (!this.personId) {
        this.$message({
          message: '被授权方不能为空',
          type: 'warning'
        })
        return
      } else if (this.checked == false && !this.new_contact.usageCount) {
        this.$message({
          message: '授权份数不能为空',
          type: 'warning'
        })
        return
      } else if (this.multipleSelectionOne.length == 0) {
        this.$message({
          message: '授权印章不能为空',
          type: 'warning'
        })
        return
      } else if (!this.new_contact.sealUsageDate) {
        this.$message({
          message: '授权截至时间不能为空',
          type: 'warning'
        })
        return
      }
      this.loading_yes = true
      this.loading = true

      for (var i = 0; i < this.multipleSelectionOne.length; i++) {
        var da = {
          sealId: this.multipleSelectionOne[i].id,
          sealName: this.multipleSelectionOne[i].name
        }
        this.recordList.push(da)
      }
      var usageCount
      if (this.checked == true) {
        usageCount = ''
      } else {
        usageCount = this.new_contact.usageCount
      }
      this.$SIF.httpPost({
        url: this.$SIF._serve.manage + '/function/issue/seal-auth',
        data: {
          personId: this.personId,
          usageCount: usageCount,
          sealUsageDate: this.$options.filters.timeFormat(this.new_contact.sealUsageDate, 'yyyy-mm-dd hh:MM:ss'),
          recordList: this.recordList,
          remark: this.new_contact.remark
        },
        succFun: res => {
          this.loading_yes = false
          this.loading = false
          this.$router.push({
            path: '/authorized_seal',
            query: {
              protocolId: res.data.protocolId,
              authId: res.data.authId
            }
          })
        },
        failFun: res => {
          this.loading_yes = false
          this.loading = false
          this.$message({
            message: res.msg,
            type: 'warning'
          })
          return
        }
      })
    },
    // 对象去重
    unique(arr) {
      const res = new Map()
      return arr.filter(arr => !res.has(arr.sealSaveID) && res.set(arr.sealSaveID, 1))
    },
    choosed(index, item) {
      // if ((Date.now() - this.onpresscTime) > 500) {
      this.onpresscTime = Date.now()
      if (this.$refs.liId[index].className == 'seal_box_list') {
        // 添加类--选中状态
        this.$refs.liId[index].className = 'seal_box_list choose'
        // this.checkBox.push(index);
        this.checkBoxData = this.unique(this.checkBoxData)
        this.checkBoxData.push(item)
      } else {
        // 选中再取消
        this.$refs.liId[index].className = 'seal_box_list'
        for (var b = 0; b < this.checkBoxData.length; b++) {
          if (this.checkBoxData[b].sealSaveID == item.sealSaveID) {
            this.checkBoxData.splice(b, 1)
          }
        }
      }
      this.mySignature = this.chunk(this.checkBoxData, 3)
      // }
    },

    _checkbox() {
      if (this.checked == true) {
        this.g_disabled = true
      } else {
        this.g_disabled = false
      }
    },
    presentContact(i) {
      this.new_contact.value = i.userAccount
      this.new_contact.remarkName = i.remarkName
      // this.getsignatory(this.is ,3)
    },
    add_auth_data() {},
    // 打开通讯录
    Address_book(i) {
      this.del_seal_dialog = true
    },
    // 获取人员信息
    get_contacts() {
      this.$SIF.httpPost({
        url: this.$SIF._serve.usermanage + '/contacts/queryPage',
        data: {
          entity: {
            queryValue: this.input3
          },
          pageBean: {
            pageSize: this.pageSize,
            pageNum: this.pageNum
          }
        },
        succFun: res => {
          var dt = res.data.list
          this.options = dt
          this.pages_total = res.data.total
        }
      })
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.get_contacts()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.get_contacts()
    },
    handleCurrentChange_one(val) {
      this.pageNum_s = val
      this.get_mySeal()
    },
    handleSizeChange_one(val) {
      this.pageNum_s = val
      this.get_mySeal()
    },
    query() {
      this.name = this.screen_form.name
      if (this.screen_form.sealType) {
        this.sealType_one = '0' + this.screen_form.sealType
      } else {
        this.sealType_one = ''
      }

      this.get_mySeal()
    },
    get_allseal() {
      var that = this
      that.$SIF.httpPost({
        url: this.$SIF._serve.seal + '/contract-seal/page/companySeal',
        data: {
          entity: {
            certification: '1'
          },
          pageBean: {
            pageNum: 1,
            pageSize: 5000
          }
        },
        succFun: res => {
          if (res.code == 10000) {
            var dt = res.data.list,
              arr = []
            this.allDate = dt
            if (dt) {
              for (var k = 0; k < dt.length; k++) {
                arr.push(dt[k].sealSaveID)
              }
              that.$SIF.downloadListFile({
                params: { ids: arr },
                succFun: function (res) {
                  that.mySeal_file = res.data
                },
                failFun: function (res) {}
              })
            }
          } else {
            that.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }
      })
    },
    // 获取印章列表
    get_mySeal() {
      var that = this
      that.$SIF.httpPost({
        url: this.$SIF._serve.seal + '/contract-seal/page/companySeal',
        data: {
          entity: {
            name: that.name,
            sealType: that.sealType_one,
            certification: '1',
            status: 1
          },
          pageBean: {
            pageNum: that.pageNum_s,
            pageSize: that.pageSize_1
          }
        },
        succFun: res => {
          if (res.code == 10000) {
            var dt = res.data.list,
              arr = []
            if (dt) {
              for (var k = 0; k < dt.length; k++) {
                this.newDATA.push(dt[k])
                arr.push(dt[k].sealSaveID)
              }
              that.mySeal = dt
              var ass = []
              var assq = []

              if (this.checkBoxData.length > arr.length) {
                for (var d = 0; d < this.checkBoxData.length; d++) {
                  for (var b = 0; b < arr.length; b++) {
                    if (this.checkBoxData[d].sealSaveID == arr[b]) {
                      ass.push(b)
                    }
                  }
                  this.$nextTick(function () {
                    var parent = document.getElementsByClassName('seal_box_list')
                    for (var old = 0; old < parent.length; old++) {
                      parent[old].className = 'seal_box_list'
                    }
                    for (var bc = 0; bc < arr.length; bc++) {
                      if (bc < ass.length) {
                        parent[ass[bc]].className = 'seal_box_list choose'
                      }
                    }
                  })
                }
              } else {
                for (var bb = 0; bb < arr.length; bb++) {
                  for (var dd = 0; dd < this.checkBoxData.length; dd++) {
                    if (this.checkBoxData[dd].sealSaveID == arr[bb]) {
                      assq.push(bb)
                    }
                  }
                }
                this.$nextTick(function () {
                  var parent = document.getElementsByClassName('seal_box_list')
                  for (var old = 0; old < parent.length; old++) {
                    parent[old].className = 'seal_box_list'
                  }
                  for (var bc = 0; bc < arr.length; bc++) {
                    if (bc < assq.length) {
                      parent[assq[bc]].className = 'seal_box_list choose'
                    }
                  }
                })
              }
            }
          } else {
            that.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
          that.pages_total_1 = res.data.total
        }
      })
    },
    chunk(arr, size) {
      var rsArr = []
      for (var i = 0; i < arr.length; i += size) {
        var tempArr = []
        for (var j = 0; j < size && i + j < arr.length; j++) {
          tempArr.push(arr[i + j])
        }
        rsArr.push(tempArr)
      }
      return rsArr
    }
  }
}
</script>

<style scoped>
.seal_carousel_item {
  padding: 0 50px;
  height: 80px;
}

.seal_33 {
  width: 33%;
  float: left;
}

.list_seal {
  width: 279px;
  height: 79px;
  border: 1px solid #23b769;
  border-radius: 4px;
  margin: 0 auto;
  padding: 5px 15px;
  position: relative;
}

.seal_box {
  height: 218px;
  background: #f5f5f5;
  border-radius: 9px;
  padding: 10px 0;
  overflow: hidden;
  margin-bottom: 20px;
}

.seal_box_div {
  width: 25%;
  float: left;
  margin-bottom: 14px;
}

.seal_box_list {
  margin: 0 auto;
  width: 226px;
  height: 90px;
  background: #ffffff;
  border: 1px solid #b3b3b3;
  border-radius: 4px;
  padding: 11px;
  position: relative;
}

.choose {
  border: 1px solid #23b769;
}

.choose_one {
  position: absolute;
  right: 0;
  top: 0;
  padding: 2px;
  background: #23b769;
  color: #ffffff;
  display: none;
}

.choose .choose_one {
  display: block;
}

.selected_seal {
  width: 322px;
  height: 244px;
  background: #f6f6f6;
  margin: 0 auto;
  padding-bottom: 15px;
}

.selected_seal_tot {
  height: 38px;
  line-height: 38px;
  font-size: 12px;
  font-family: SourceHanSansCN, SourceHanSansCN-Regular;
  font-weight: 400;
  color: #3e3e3e;
  padding-left: 14px;
  margin: 0;
}

.selected_seal_list {
  height: -webkit-calc(100% - 38px);
  height: -moz-calc(100% - 38px);
  height: calc(100% - 38px);
  overflow-x: hidden;
  overflow-y: auto;
}

.selected_seal_list_div {
  width: 282px;
  height: 58px;
  background: #ffffff;
  margin: 2px auto;
  padding: 7px 13px;
  position: relative;
}

.del_button {
  position: absolute;
  right: 0;
  top: 0;
  padding: 0;
  border: 0;
  height: 100%;
  width: 26px;
  background: #ffe8e8;
  color: #ff5a5a;
}

.del_button_one {
  position: absolute;
  right: 0;
  top: 0;
  padding: 1px;
  background: #23b769;
  color: #ffffff;
  cursor: pointer;
}

.selected_seal_list_img {
  width: 44px;
  height: 44px;
  float: left;
}

.selected_seal_list_test {
  width: -webkit-calc(100% - 44px);
  width: -moz-calc(100% - 44px);
  width: calc(100% - 44px);
  font-size: 12px;
  font-family: SourceHanSansCN, SourceHanSansCN-Regular;
  font-weight: 400;
  color: #596f64;
  float: right;
  line-height: 16px;
  padding-left: 5px;
  padding-right: 26px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.seal_box_list_img {
  width: 67px;
  height: 67px;
  overflow: hidden;
  float: left;
}

.seal_box_list_img >>> .el-image__inner--center,
.img_seal >>> .el-image__inner--center {
  -webkit-transform: translate(-50%, 0%);
  transform: translate(-50%, 0%);
}

.seal_box_list_test {
  width: -webkit-calc(100% - 75px);
  width: -moz-calc(100% - 75px);
  width: calc(100% - 75px);
  float: right;
  text-align: right;
  font-size: 12px;
  font-family: SourceHanSansCN, SourceHanSansCN-Regular;
  font-weight: 400;
  text-align: right;
  color: #596f64;
  line-height: 16px;
}

.seal_box_list_test p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.img_seal {
  width: 67px;
  height: 67px;
  float: left;
}

.msg_seal {
  width: -webkit-calc(100% - 75px);
  width: -moz-calc(100% - 75px);
  width: calc(100% - 75px);
  float: right;
  text-align: left;
}

.text {
  font-size: 12px;
  font-family: SourceHanSansCN, SourceHanSansCN-Regular;
  font-weight: 400;
  text-align: left;
  color: #596f64;
  line-height: 16px;
}

.aut_add_forom {
  width: 50%;
  margin: 0 auto;
  padding: 20px 0;
}
.demo-form-inline {
  text-align: left;
}

.aut_add_forom >>> .el-form-item__label,
.demo-form-inline >>> .el-form-item__label {
  color: #9e9e9e;
}

.order_list {
  height: 100%;
  overflow: hidden;
}

.child {
  height: 100%;
}

.butn_one {
  float: left;
  position: absolute;
  left: 25px;
  top: 7px;
}

.order_list_p {
  width: 150px;
  float: left;
  position: absolute;
  left: 100px;
  top: 0;
  margin: 0;
}

.bottom_button {
  width: 100%;
  text-align: center;
  padding: 20px 0;
}

.qued_button {
  border-radius: 8px;
  color: #ffffff;
  background: #31ca84;
  padding: 0;
  width: 117px;
  height: 33px;
}

.quxiao_button {
  border: 1px solid #31ca84;
  border-radius: 8px;
  color: #31ca84;
  background: #ffffff;
  padding: 0;
  width: 117px;
  height: 33px;
}

.el_dialoge >>> .el-dialog {
  width: 1030px !important;
}

.el_dialoge_box {
}

.query-bar {
  height: 40px;
  margin-bottom: 15px;
}

.query-bar .el-form-item {
  margin-bottom: 0;
}

.image_class {
  width: 60px;
  height: 60px;
  vertical-align: middle;
  display: table-cell;
}

.name_test p {
  margin: 0;
  height: 20px;
  line-height: 20px;
  color: #959595;
}

.aut_add_forom .el-input,
.remark_input {
  width: 207px;
}

.mySeal_button {
  width: 207px;
  background: #ffffff;
  border: 1px solid #23b769;
  border-radius: 3px;
  color: #23b769;
}

.mySeal_button:hover {
  background: #23b769;
  color: #ffffff;
}

.el-button_icon {
  margin-right: 15px;
  border: none;
  height: 30px;
  padding: 0;
  position: absolute;
  left: 224px;
  background: #ffffff;
  top: 1px;
  color: #31ca84;
  overflow: hidden;
}

.el-button_icon >>> .iconfont,
.buyyon_icon >>> .el-icon-date {
  font-size: 25px;
}

._checkbox {
  margin-left: 15px;
}

.buyyon_icon {
  margin-left: 15px;
  border: none;
  height: 30px;
  padding: 0;
  font-size: 18px;
  color: #35cb86;
  background: #ffffff;
}

.el_input_number .el-input__inner,
.el_input_number {
  width: 207px;
}

._checkbox >>> .el-checkbox__inner {
  zoom: 140%;
}

.contact_tb_all {
  border: 1px solid #31ca84;
}

.contact_tb_all >>> .el-table__row {
  height: 40px;
}

.contact_tb_all th.is-leaf,
.contact_tb_all td {
  border: 0.01852rem solid #31ca84 !important;
}

.con_input {
  width: 100%;
  text-align: center;
  margin-bottom: 15px;
}

.input-with-select {
  width: 225px;
  height: 30px;
}

.input-with-select >>> .el-input__inner {
  height: 30px;
  border-radius: 15px 0 0 15px;
  border-right: 0;
}

.input-with-select >>> .el-input-group__append {
  border-radius: 0 15px 15px 0;
  background: #ffffff;
}

.input-with-select >>> .el-input__inner:focus {
  border-color: #dcdfe6 !important;
}

.selected_box {
  width: 100%;
  height: 64px;
  padding: 5px 10px;
  overflow-y: hidden;
  overflow-x: auto;
  display: -webkit-box;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
}

.selected_box::-webkit-scrollbar,
.selected_seal_list::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

.selected_box::-webkit-scrollbar-thumb,
.selected_seal_list::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.selected_box::-webkit-scrollbar-track,
.selected_seal_list::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.selected_div {
  width: 200px;
  height: 42px;
  border: 1px solid #23b769;
  border-radius: 4px;
  margin-right: 15px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #333333;
  line-height: 20px;
  padding-left: 5px;
  padding-top: 2px;
  position: relative;
  padding-right: 20px;
}

.selected_div::-webkit-scrollbar {
  background-color: transparent;
  display: none;
}

.selected_div span,
.selected_div p {
  margin: 0;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.data_null {
  width: 100%;
  text-align: center;
  line-height: 50px;
  font-size: 18px;
}

.button_bottom {
  width: 100%;
  text-align: center;
}
.seal_box,
.list {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}
</style>